import type { EntitiesState } from '@redux/entities'
import type { ProviderModel, ProviderPackageModel } from '@models/types'

type FilterProvidersWithPackagesParams = {
  providers: EntitiesState['providers'],
  providerPackages: ProviderPackageModel[],
}

const filterProvidersWithPackages = (params: FilterProvidersWithPackagesParams) => {
  const { providers, providerPackages } = params

  const providersWithPackages = providerPackages.reduce((acc, providerPackage) => {
    const provider = providers[providerPackage.provider_id]

    if (provider && !acc[provider.id]){
      acc[provider.id] = provider
    }

    return acc
  }, {} as { [key: number]: ProviderModel })

  return { providersWithPackages: Object.values(providersWithPackages) }
}

export default filterProvidersWithPackages
